<div class="bottom-sheet-content" #gestureArea>
  <div class="sheet-header">
    <div class="handle-bar"></div>
    <div class="back-button" (click)="cancel()" (keydown)="cancel()" tabindex="0">
      <img src="assets/ic-close.svg" alt="cancel icon" />
    </div>
  </div>

  <div class="title section-title-container">
    <h2>Switch Charity</h2>
    <ion-note>Select which charity to manage</ion-note>
  </div>

  <div class="charity-list">
    <ion-list lines="none">
      <ion-item 
        *ngFor="let charity of permittedCharities" 
        button 
        (click)="selectCharity(charity)"
        [disabled]="isSwitching"
        [class.selected]="charity.id === currentCharityId"
      >
        <div class="charity-item">
          <div class="image-wrapper square small">
            <ion-skeleton-text animated *ngIf="!imageLoadedMap[charity.id] && charity.avatarUrl"></ion-skeleton-text>
            <ion-img 
              [alt]="charity.name + ' logo'" 
              [src]="charity.avatarUrl || 'assets/ic-charity.svg'"
              (ionImgDidLoad)="onImageLoad(charity.id)"
              [class.hidden]="!imageLoadedMap[charity.id] && charity.avatarUrl"
              [class.fade-in]="charity.avatarUrl"
            ></ion-img>
          </div>
          <div class="charity-info">
            <ion-label>
              <h3>{{ charity.name }}</h3>
              <p *ngIf="charity.city && charity.state">{{ charity.city }}, {{ charity.state }}</p>
            </ion-label>
          </div>
          <ion-icon 
            *ngIf="charity.id === currentCharityId" 
            name="checkmark-circle" 
            color="primary"
            class="selected-icon"
          ></ion-icon>
        </div>
      </ion-item>
    </ion-list>
  </div>

  <div class="action-footer" *ngIf="isSwitching">
    <ion-spinner name="crescent"></ion-spinner>
    <ion-text color="medium">Switching charity...</ion-text>
  </div>
</div>